export const PSObjTwo = {

    lightBg : false,
    lightText : true,
    lightTextDesc : true,
    topLine : 'bani bayani',
    headline : 'The Nigerian Talking Calculator App',
    description : 'This mobile app BANI BAYANI allows you to perform your basic calculations ' + 
    'in Nigerian Languages of Hausa, Igbo and Yoruba. It is one of the new products ' +
    'from our Software Development Partners - ybCodeLab. It is available on Adroid and IOS ',
    buttonLabel : 'Download App',
    buttonLabel1 : 'Terms & Conditions',
    imgStart : 'end',
    img : '../../banibayaniLogo.gif',
    alt: 'Bani Bayani'
}